/**
 * Built-ins used by Inertia and our app that older Safari versions lack.
 * Import before other app modules: Vite transforms syntax, not built-in APIs.
 */
function define(target, name, value) {
    if (!(name in target)) {
        Object.defineProperty(target, name, { value, writable: true, configurable: true })
    }
}

define(Object, 'hasOwn', function hasOwn(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key)
})

function requireObject(value) {
    if (value == null) {
        throw new TypeError('Cannot convert undefined or null to object')
    }
    return Object(value)
}

function lengthOf(object) {
    return Math.min(Math.max(Math.trunc(+object.length) || 0, 0), Number.MAX_SAFE_INTEGER)
}

function at(index) {
    const object = requireObject(this)
    const length = lengthOf(object)
    let i = Math.trunc(index) || 0
    if (i < 0) i += length
    return i < 0 || i >= length ? undefined : object[i]
}
define(Array.prototype, 'at', at)
define(String.prototype, 'at', function (index) {
    requireObject(this)
    return at.call(`${this}`, index)
})

define(Array.prototype, 'findLast', function findLast(predicate, thisArg) {
    const object = requireObject(this)
    const length = lengthOf(object)
    if (typeof predicate !== 'function') {
        throw new TypeError('Predicate must be a function')
    }
    for (let i = length - 1; i >= 0; i--) {
        const value = object[i]
        if (predicate.call(thisArg, value, i, object)) return value
    }
    return undefined
})
define(Array.prototype, 'findLastIndex', function findLastIndex(predicate, thisArg) {
    const object = requireObject(this)
    const length = lengthOf(object)
    if (typeof predicate !== 'function') {
        throw new TypeError('Predicate must be a function')
    }
    for (let i = length - 1; i >= 0; i--) {
        if (predicate.call(thisArg, object[i], i, object)) return i
    }
    return -1
})
